import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../../APIHelpers/Responses";

export const subCategoryServices = {
  addNewBlogSubCategory,
  updatedBlogSubCategory,
  softDeleteRestoreBlogSubCategory,
  deleteBlogSubCategory,
  getBlogSubCategoryList,
};

// Add New Bank Meta
async function addNewBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogSubCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Bank Meta
async function updatedBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Bank Meta
async function softDeleteRestoreBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Bank Meta
async function deleteBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogSubCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Bank Meta
async function getBlogSubCategoryList(categoryId, status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogSubCategoryList/${categoryId}/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogSubCategoryList/${categoryId}/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}